import React from "react";
import "./style.css";
import styled from 'styled-components';

const ReviewHeader = () => {
    return (
        <Box>
            <div className="headerUp">
            <span>Topic: HTML</span>
            <span>
                Score: 45/100 | 45%
            </span>
            </div>
            
            <div className="headerDown">
                <span>Submitted on 29-09-2023 | 12:15</span>
                <span>Time Taken: 35:03</span>
            </div>
            
        </Box>
    );
};

export default ReviewHeader;


const Box = styled.div`
width: calc(100% - 10rem);
margin: -1rem auto;
display: flex;
flex-direction: column;
height: 10rem;
border: 0.1rem solid var(--light-color);
border-top-left-radius: 1rem;
border-top-right-radius: 1rem;
justify-content: space-between;
padding: 2rem 5rem;



.headerUp {
    display: flex;
    justify-content: space-between;
}

.headerDown {
    display: flex;
    gap: 6rem;

    span {
        color: var(--light-color);
    }
}

`